import React from "react"
import "../../styles/outcome-section.scss"
import { OutcomeCard } from "./outcome-card"

export const OutcomeCardGrid = ({ items }) => {
  return (
    <div className="outcome-card-grid">
      {items.map((item, index) => (
        <OutcomeCard key={index} {...item} />
      ))}
    </div>
  )
}
